import { v4 as uuid } from 'uuid';
import DropdownMenu from '@/components/DropdownMenu.vue';

export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      expanded: false,
      buttonId: `id${uuid()}`,
      menuId: `id${uuid()}`,
      observer: null,
    };
  },
  mounted() {
    document.addEventListener('click', this.documentClickListener);

    const menu = document.querySelector(`#${this.menuId}`);

    this.observer = new MutationObserver(this.mutationObserverCallback);

    this.observer.observe(menu, { attributes: true });
  },
  beforeDestroy() {
    this.observer.disconnect();
    document.removeEventListener('click', this.documentClickListener);
  },
  computed: {
    ariaExpanded() {
      return this.expanded ? 'true' : 'false';
    },
  },
  methods: {
    mutationObserverCallback(mutationList) {
      const menu = mutationList[0].target;
      const hidden = !!menu.getAttribute('hidden');
      if (hidden) {
        menu.parentElement.dataset.menuPosition = '';
        return;
      }
      this.handleCollisions(menu);
    },
    handleCollisions(target) {
      const { bottom, x } = target.getBoundingClientRect();

      const menuWrapper = target.parentElement;

      const hitBottom = bottom > window.innerHeight;
      const hitLeft = x < 0;

      switch (true) {
        case hitBottom:
          menuWrapper.dataset.menuPosition = 'top';
          break;
        case hitLeft:
          menuWrapper.dataset.menuPosition = 'right';
          break;
        default:
          menuWrapper.dataset.menuPosition = '';
      }
    },
    expand(evt) {
      if (this.expanded) return;
      this.setMenuIdToEvent(evt);
      this.expanded = true;
    },
    setMenuIdToEvent(evt) {
      evt.menu = this.menuId;
    },
    documentClickListener(evt) {
      if (evt.menu !== this.menuId) {
        this.expanded = false;
      }
    },
  },
};
